import { createI18n } from 'vue-i18n';

function loadLocalizations() {
    const regExPattern = /[a-z]{2}_[A-Z]{2}/
    const localizations = Object.entries(
        import.meta.glob('./localization/*.json', { eager: true })
    )

    const messages = {};
    for (const [key, value] of localizations) {
        const matched = key.match(regExPattern);

        if (matched && matched.length) {
            const localization = matched[0];
            messages[localization] = JSON.parse(JSON.stringify(value)).default;
        }
    }
    return messages;
}

const i18n = createI18n({
    globalInjection: true,
    locale: 'en_GB',
    fallbackLocale: 'en_GB',
    messages: loadLocalizations()
});

export default i18n;